import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorHeading: {
		id: 'atlassian-navigation.common.menu.error.error-heading',
		defaultMessage: 'Something went wrong',
		description: 'telling users that an error has occurred',
	},
	errorBody: {
		id: 'atlassian-navigation.common.menu.error.error-body',
		defaultMessage: 'Try refreshing or navigating to another page.',
		description: 'Suggest an action to the user',
	},
	errorImg: {
		id: 'atlassian-navigation.common.menu.error.error-img',
		defaultMessage: 'An image showing that an error has occurred',
		description: 'Alt text for error image',
	},
});
